import script from "./PrintBatchLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintBatchLabel.vue?vue&type=script&setup=true&lang=js"

import "./PrintBatchLabel.vue?vue&type=style&index=0&id=c78c1fa8&lang=css"

const __exports__ = script;

export default __exports__